import { call, put, takeLatest } from 'redux-saga/effects';

import { userApi } from '../../../api';

import { updateQueryString } from '../../router/actions';
import { pushNotification } from '../../ui/actions';
import * as actions from './actions';

function* requestPasswordReset({ email }) {
  try {
    yield put({ type: actions.RESET_PASSWORD_REQUEST_PENDING });
    const { status } = yield call(userApi.requestPasswordReset, email);

    if (status === 200) {
      yield put({ type: actions.RESET_PASSWORD_REQUEST_FULFILLED });
      yield put(updateQueryString({ modal: undefined }));
      yield put(
        pushNotification({
          title: 'Password reset email sent',
          description: 'You will receive a link to reset your password.',
          duration: 0,
        }),
      );
    }
  } catch (e) {
    yield put({ type: actions.RESET_PASSWORD_REQUEST_REJECTED, payload: e });
  }
}

export function* watchRequestPasswordReset() {
  yield takeLatest(actions.RESET_PASSWORD_REQUEST, requestPasswordReset);
}
